import {
  textUI,
  titleUI,
  selectUI,
  checkboxUI,
  checkboxSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import {
  STATE_VALUES,
  STATE_NAMES,
  COUNTRY_VALUES,
  COUNTRY_NAMES,
} from '../../../../utils/labels';
import { customAddressSchema } from '../../../../config/definitions';
import content from '../../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI('Where did the Veteran’s death occur?'),
    marriageToVeteranEndDeathOutsideUs: checkboxUI({
      title: 'The Veteran died outside the U.S.',
    }),
    marriageToVeteranEndDeathLocation: {
      city: {
        ...textUI(content['address-city']),
        'ui:errorMessages': {
          required: content['address-city-error'],
        },
      },
      state: {
        ...selectUI(content['address-state']),
        'ui:required': formData =>
          !formData?.marriageToVeteranEndDeathOutsideUs,
        'ui:options': {
          hideIf: formData => formData?.marriageToVeteranEndDeathOutsideUs,
          labels: STATE_VALUES.reduce((acc, value, idx) => {
            acc[value] = STATE_NAMES[idx];
            return acc;
          }, {}),
        },
        'ui:errorMessages': {
          required: content['address-state-error'],
        },
      },
      otherCountry: {
        ...selectUI(content['address-country']),
        'ui:required': formData => formData?.marriageToVeteranEndDeathOutsideUs,
        'ui:options': {
          hideIf: formData => !formData?.marriageToVeteranEndDeathOutsideUs,
          labels: COUNTRY_VALUES.reduce((acc, value, idx) => {
            acc[value] = COUNTRY_NAMES[idx];
            return acc;
          }, {}),
        },
        'ui:errorMessages': {
          required: content['address-country-error'],
        },
      },
    },
  },
  schema: {
    type: 'object',
    required: ['marriageToVeteranEndDeathLocation'],
    properties: {
      marriageToVeteranEndDeathOutsideUs: checkboxSchema,
      marriageToVeteranEndDeathLocation: customAddressSchema,
    },
  },
};
